import {useInitializeFundamentalTheme} from './initializeFundamentalTheme'

/**
 * Should be used inside ThemeProvider
 * This component is used to initialize the theme of the application
 */

export const ThemeInitializer = () => {
  useInitializeFundamentalTheme()
  return null
}
